import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container, Stack,
  TextField,
  useTheme
} from "@mui/material";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import CountingHeroLogo from "src/components/CountingHeroIcon";

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["login"])),
  },
});

const Login = () => {
  const theme = useTheme();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation("login");

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const localStorageItem = localStorage.getItem("dts-should-redirect");
    if (localStorageItem) router.push("/dashboard");
  }, [router]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const body = {
      username: username,
      password: password,
    };

    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      if (res.status === 200) {
        localStorage.setItem("dts-should-redirect", true);

        setTimeout(() => {
          setLoading(false);
          router.push("/dashboard");
        }, 600);
      } else {
        enqueueSnackbar(t("errors.notFound"), { variant: "error" });
        throw new Error(await res.text());
      }
    } catch (error) {
      setLoading(false);
      console.error(t("errors.unknown"), error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="xs" component="form" onSubmit={handleSubmit}>
        <Card
          sx={{
            backgroundColor: theme.brandColor,
          }}
        >
          <CardContent
            sx={{ gap: 5, flexDirection: "column", display: "flex" }}
          >
            <Stack direction="column" alignItems="center" width="100%">
              <CountingHeroLogo width="90px" />
            </Stack>

            <TextField
              label={t("email")}
              placeholder={t("emailPlaceholder")}
              required
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              hidden={false}
            />

            <TextField
              label={t("password")}
              required
              placeholder={t("passwordPlaceholder")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
            />
          </CardContent>
          <CardActions
            disableSpacing
            sx={{ flexDirection: "column", gap: "10px" }}
          >
            <Button
              fullWidth
              onClick={() => router.replace("/auth/forgotPassword")}
              variant="text"
            >
              {t("forgotPassword")}
            </Button>
            <LoadingButton
              loading={loading}
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
            >
              {t("submit")}
            </LoadingButton>
          </CardActions>
        </Card>
      </Container>
    </Box>
  );
};

export default Login;
